export default {
    brands: {
        items: [],
        status: 'NOT_FETCHED'
    },
    searches: {
        items: [],
        status: 'NOT_FETCHED'
    },
    recentSearches: {
        lastUpdated: null
    }
};
